import { render } from "./Trash.vue?vue&type=template&id=59757463"
import script from "./Trash.vue?vue&type=script&lang=js"
export * from "./Trash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Icons/Trash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59757463"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59757463', __exports__)) {
    api.reload('59757463', __exports__)
  }
  
  module.hot.accept("./Trash.vue?vue&type=template&id=59757463", () => {
    api.rerender('59757463', render)
  })

}


export default __exports__